module.exports = {
  "device": {
    "deviceManager": "设备管理",
    "tenantName": "租户名称",
    "tenantNameHint": "请输入租户名称",
    "tenantNameHint2": "请选择租户名称",
    "deviceName": "设备名称",
    "deviceNameHint": "请输入设备名称",
    "deviceType": "设备类型",
    "deviceTypeHint": "请选择设备类型",
    "deviceInfo": "设备信息",
    "deviceInfoHint": "请输入设备信息",
    "deviceList": "设备列表",
    "batch": "批次",
    "batchHint": "请输入设备批次",
    "deviceId": "设备ID",
    "deviceIdHint": "请输入设备ID",
    "activeTime": "激活时间",
    "lastOnlineTime": "最后上线时间",
    "activeStatus": "激活状态",
    "deviceStatus": "设备状态",
    "deleteDeviceHint": "删除该设备 {0} 将不可恢复，确定吗？",
    "addDevice": "添加设备",
    "editDevice": "编辑设备",
    "deviceActivation": "设备激活",
    "activation": "激活",
    "activationDevice": "激活设备"
  },
  "deviceOpsRecord": {
    'tabTitle': '授权',
    'pageTitle': '运行记录',
    'listTitle': '记录列表',
    'tenantName': '租户名称',
    'deviceName': '设备名称',
    'deviceInfo': '设备信息',
    'activeSeconds': '当前运行时长（秒）',
    'onlineTime': '上线时间',
    'offlineTime': '下线时间',
    'search_input1': '租户名称',
    'search_input2': '设备名称',
    'search_input3': '设备信息'
  }
}


// WEBPACK FOOTER //
// ./src/i18n/device/zh-CN.js